module.exports = __webpack_public_path__ + "img/designer-smiles-logo.6950abb2.jpg";